import gql from 'graphql-tag';

export const SITE_MENUS_FRAGMENT = gql`
    fragment SiteMenusFragment on SiteMenus {
        siteId
        columns {
            columnId
            dailyMenus {
                date
                productLocations {
                    product {
                        _id
                        fullname
                    }
                    location {
                        _id
                    }
                }
            }
        }
    }
`;

export const MENU_PRODUCT_FRAGMENT = gql`
    fragment MenuProductFragment on MenuProduct {
        product {
            _id
            fullname
            imageUrl
            state
            isMicrostore
            isToBeArchived
            isWithoutStock
            supplier {
                _id
                name
            }
        }
        quantity
        nbLocations
        isInProductArrangement
    }
`;

export const MENU_PRODUCT_ARRANGEMENT_FRAGMENT = gql`
    fragment MenuProductArrangementFragment on MenuProductArrangement {
        productArrangementId
        productArrangementName
        productArrangementMainCategoryId
        productArrangementIndexes {
            productArrangementIndex
            rotations {
                rotationNumber
                products {
                    ...MenuProductFragment
                }
            }
        }
    }
    ${MENU_PRODUCT_FRAGMENT}
`;
